export const GET_EMERGENCY_ITEMS = 'GET_EMERGENCY_ITEMS';
export const SET_EMERGENCY_ITEMS = 'SET_EMERGENCY_ITEMS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_EMERGENCY_ITEM = 'SET_EMERGENCY_ITEM';
export const ADD_EMERGENCY_ITEM = 'ADD_EMERGENCY_ITEM';
export const EMPTY_EMERGENCY_ITEM = 'EMPTY_EMERGENCY_ITEM';
export const DELETE_EMERGENCY_ITEM = 'DELETE_EMERGENCY_ITEM';
export const EDIT_EMERGENCY_ITEM = 'EDIT_EMERGENCY_ITEM';
export const UPDATE_EMERGENCY_ITEM = 'UPDATE_EMERGENCY_ITEM';
export const SET_EMERGENCY_ITEM_FILTER = 'SET_EMERGENCY_ITEM_FILTER';